// File: src/index.js
// Description: Entry point for React app; renders the main App component into the #root element in index.html

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ✅ Import the service worker registration file
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Create a root using the new ReactDOM.createRoot API (React 18+)
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component wrapped in StrictMode for highlighting potential problems
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Register the service worker (this enables PWA features like offline support)
serviceWorkerRegistration.register();
